import type { Currency } from '@backmarket/http-api'
import { getCustomerId } from '@backmarket/http-api/src/api-specs-crm-service/crm-service/customer'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

export function useUpdateTrackingUserContext() {
  return {
    updateTrackingUserContext: async () => {
      const { user, isUserAuthenticatedStaff } = useUserStore()
      const { isImpersonated } = useSellerInfoStore()
      const tracking = useTracking()
      const logger = useLogger()
      const currentMarketplace = useMarketplace().market.marketplace

      if (!user.value.userId) {
        return
      }

      try {
        tracking.setUserContext({
          userId: user.value.userId,
          isStaff: isImpersonated || isUserAuthenticatedStaff.value,
          clientId: user.value.clientId,
          bmUserId: user.value.bmUserId,
          merchantId: user.value.merchantId
            ? user.value.merchantId.toString() + currentMarketplace
            : '',
          emailHashed: user.value.emailHashed || '',
          numberOfOrders: user.value.numberOfOrders,
          lastOrderDate: String(user.value.lastOrderDate),
          lifetimeRevenue: {
            currency: <Currency>user.value.lifetimeRevenue.currency || '',
            amount: String(user.value.lifetimeRevenue.amount),
          },
        })

        if (user.value.clientId) {
          const { crmId } = await $httpFetch(getCustomerId)
          tracking.setCrmId(crmId)
        }
      } catch (err) {
        const error = err as Error
        logger.error(error.message, {
          error,
          owners: ['bot-squad-seller-experience-front'],
        })
      }
    },
  }
}
